export const isMobile = window.innerWidth < 500

export const isApple = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent)
